import { get } from './api';
import { NotificationProps } from '../components';
import { Paginated } from './api';

export const endpoints = {
  notificationsUrl: `${window.envConfig.SELLERS_API_BASE_URL}notifications`,
  markNotificationReadUrl: `${window.envConfig.SELLERS_API_BASE_URL}notifications/markRead`,
};

export const getNotifications = async (
  token: string,
  urlParams: Record<string, string>
): Promise<Paginated<NotificationProps>> => {
  const results = await get<Paginated<NotificationProps>>({
    url: endpoints.notificationsUrl,
    urlParams,
    token,
    paginated: true,
  });
  return results;
};

export const markNotificationRead = async () => {
  // const results = await get<NotificationProps[]>({
  //   url: endpoints.notificationsUrl,
  // });
  // return results;

  return true;
};
